/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/QaCoverSizeFields.tsx
 * FILE_ID: JOBHUB-QA-COVER-SIZE-FIELDS-001
 * PURPOSE: H and W (mm) boxes under each Cover image upload; the cap keeps the cover on page 1.
 */
import type { KeyboardEvent as ReactKeyboardEvent } from 'react'
import {
  ITP_COVER_IMAGE_DEFAULT_MM,
  ITP_COVER_IMAGE_MAX_MM,
  ITP_COVER_IMAGE_MIN_MM,
} from '../../qa/itpCover'

export function QaCoverSizeFields({
  inputClassName,
  heightMm,
  widthMm,
  onHeightMm,
  onWidthMm,
  onCommit,
}: {
  inputClassName: string
  heightMm: number
  widthMm: number
  onHeightMm: (value: number) => void
  onWidthMm: (value: number) => void
  onCommit: () => void
}) {
  const onEnter = (event: ReactKeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') return
    event.preventDefault()
    onCommit()
  }
  const box = (
    label: string,
    aria: string,
    value: number,
    max: number,
    placeholder: string,
    onChange: (value: number) => void,
  ) => (
    <label className="block min-w-0 text-sm">
      <span className="mb-1 block">{label}</span>
      <input
        className={inputClassName}
        type="number"
        inputMode="numeric"
        aria-label={aria}
        min={ITP_COVER_IMAGE_MIN_MM}
        max={max}
        step={1}
        placeholder={placeholder}
        value={value > 0 ? value : ''}
        onChange={(event) => onChange(Number(event.target.value) || 0)}
        onBlur={onCommit}
        onKeyDown={onEnter}
      />
    </label>
  )
  return (
    <div className="grid min-w-0 grid-cols-2 gap-2">
      {box(
        'H (mm)',
        'Cover image height (mm)',
        heightMm,
        ITP_COVER_IMAGE_MAX_MM.height,
        String(ITP_COVER_IMAGE_DEFAULT_MM.height),
        onHeightMm,
      )}
      {box(
        'W (mm)',
        'Cover image width (mm)',
        widthMm,
        ITP_COVER_IMAGE_MAX_MM.width,
        String(ITP_COVER_IMAGE_DEFAULT_MM.width),
        onWidthMm,
      )}
    </div>
  )
}
